<template>
  <div class="bce-student-wrapper">
    <!-- El sidebar y topbar ahora residen en App.vue para persistencia -->
    
    <!-- MAIN CONTENT AREA -->
    <v-container fluid class="px-md-8 py-md-6 pa-4 bce-content-container" style="min-height: calc(100vh - 64px);">
      
      <!-- Slot Central -->
      <div class="w-100 bce-module-wrapper">
        <slot></slot>
      </div>

    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // La lógica global se movió a App.vue
    };
  },
  mounted() {
    // Mantener compatibilidad
  },
  computed: {
    token() { return this.$store.getters.token; },
    user() { return this.$store.getters.user; }
  }
};
</script>

<style scoped>
.bce-module-wrapper {
  animation: slideUp 0.5s ease-out;
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>